import * as Actions from '../../actions';

const initialState = { data: null };

const listUserReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_USER_LIST_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default listUserReducer;
